<template>
  <v-layout row justify-center>
    <v-dialog
      v-model="isVisible"
      fullscreen
      hide-overlay
      persistent
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title v-text="client ? client.name:''"></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items></v-toolbar-items>
        </v-toolbar>
        <v-container v-if="client">
          <v-card-text>
            <v-btn fab small color="green" v-if="client.phoneNumber" class="my-5">
              <a :href="`tel:${client.phoneNumber}`" style="text-decoration: none">
                <v-icon dark color="white">mdi-phone</v-icon>
              </a>
            </v-btn>
            <v-divider></v-divider>
            <template v-if="client.appointments.length > 0">
              <v-subheader>Client history</v-subheader>
              <client-history
                v-for="(item, index) in client.appointments"
                :key="index"
                :appointment="item"
              ></client-history>
              <v-divider></v-divider>
            </template>
            <template v-if="client.upcomingappointment.length > 0">
              <v-subheader>Upcoming appointment</v-subheader>
              <upcoming-appointment :appointment="client.upcomingappointment[0]"></upcoming-appointment>
              <v-divider></v-divider>
            </template>
            <template>
              <v-subheader>Send private SMS</v-subheader>
              <SmsBox :client="client"></SmsBox>
              <v-divider></v-divider>
            </template>
            <template>
              <client-form :client="client"></client-form>
              <v-divider></v-divider>
            </template>
          </v-card-text>
          <v-card-actions>
            <v-dialog v-model="deleteDialogisVisible" justify-center max-width="290">
              <template v-slot:activator="{ on }">
                <v-subheader>Delete client</v-subheader>
                <v-btn small v-on="on" fab dark color="red">
                  <v-icon dark>mdi-delete</v-icon>
                </v-btn>
              </template>
              <v-card color="grey lighten-4">
                <v-toolbar dark color="red">
                  <v-card-title>Delete {{this.client.name}}</v-card-title>
                </v-toolbar>

                <v-card-actions justify-space-around>
                  <v-btn dark color="grey" @click="CloseConfirmDialog()">Cancel</v-btn>
                  <v-btn dark color="error" @click="DeleteClient()">Delete</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ClientHistory from "../main/client/ClientHistory";
import UpcomingAppointment from "../main/client/UpcomingAppointment";
import SmsBox from "../main/client/SmsBox";
import clientForm from "../main/client/ClientForm";
import axios from "axios";

export default {
  data() {
    return {
      client: null,
      isVisible: false,
      deleteDialogisVisible: false
    };
  },
  created() {},
  mounted() {},
  validations: {},
  methods: {
    closeDialog() {
      this.isVisible = false;
      this.client = null;
      this.$emit("AfterClosingDilaog");
    },
    OpenDialog() {
      this.$v.$reset();
      this.isVisible = true;

      //this.GetClientData();
    },

    DeleteClient() {
      let mutation = ` mutation deleteclient($id: String!) {
                                deleteclient(id: $id) {
                                id,
                                name
                                }
                            }`;
      axios
        .post("/graphql", {
          query: mutation,
          variables: { id: this.client.id }
        })
        .then(res => {
          if (res.data) {
            this.deleteDialogisVisible = false;
            this.showSuccess(
              ` ${res.data.data.deleteclient.name} has been delted!`
            );
            this.closeDialog();
          }
        })
        .catch(() => {
          this.showError("Error occured while deleting client!");
        });
    },
    OpenConfirmDialog() {
      this.deleteDialogisVisible = true;
    },
    CloseConfirmDialog() {
      this.deleteDialogisVisible = false;
    }
  },
  computed: {},
  components: {
    ClientHistory,
    UpcomingAppointment,
    SmsBox,
    clientForm
  }
};
</script>

<style>
</style>
